import { useCallback, useEffect, useState } from 'react';

export interface Aviso {
  texto: string;
  erro?: boolean;
}

/** Toast de 2,6 s, ancorado no topo direito (ou acima da tab bar no mobile). */
export function useToast() {
  const [aviso, setAviso] = useState<Aviso | null>(null);

  useEffect(() => {
    if (!aviso) return;
    const t = window.setTimeout(() => setAviso(null), 2600);
    return () => window.clearTimeout(t);
  }, [aviso]);

  const avisar = useCallback((texto: string, erro = false) => setAviso({ texto, erro }), []);

  return { aviso, avisar };
}

export function Toast({ aviso, mobile }: { aviso: Aviso | null; mobile?: boolean }) {
  if (!aviso) return null;
  return (
    <div
      className={`sga-toast${aviso.erro ? ' sga-toast--erro' : ''}`}
      role="status"
      aria-live="polite"
      style={mobile ? { top: 'auto', bottom: 80, left: 14, right: 14 } : undefined}
    >
      <span className="sga-toast__ponto" />
      {aviso.texto}
    </div>
  );
}
